/**
 * attribution.js
 * ─────────────────────────────────────────────────────────────────
 * Captures Google Ads / campaign attribution params from the URL on
 * first load and persists them in sessionStorage so they survive
 * client-side navigation (e.g. the visitor scrolls, comes back,
 * then submits the form later in the same session).
 *
 * Expected Google Ads Final URL suffix, e.g.:
 *   https://shelf-e.com/?lp=1
 *     &utm_source=google&utm_medium=cpc&utm_campaign={campaignid}
 *     &utm_term={keyword}&utm_content={adgroupid}&gclid={gclid}
 */

const STORAGE_KEY = "shelfe_attribution";

const TRACKED_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
];

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    TRACKED_PARAMS.forEach((key) => {
      const val = params.get(key);
      if (val) found[key] = val;
    });

    if (Object.keys(found).length > 0) {
      // New attribution on the URL wins — overwrite whatever was stored
      // before (handles a visitor who arrives from a second ad click).
      found.landing_page = window.location.pathname + window.location.search;
      found.captured_at = new Date().toISOString();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
      return found;
    }
  } catch (e) {
    // sessionStorage can throw in some privacy modes — fail silently,
    // attribution is a nice-to-have, never block the form.
  }
  return getAttribution();
}

export function getAttribution() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}
